<template>
  <div class="table-wrapper">
    <div class="table-row">
      <div
        v-for="(value, index) in tableHeader"
        :key="index"
        class="table-cell"
      >
        <span class="fontS header-text">{{ value.name }}</span>
        <div
          class="hihi"
          style="display: inline-block"
          v-if="value.isSorted"
          @click="sortByKey(value.key, isAsc)"
        >
          <div class="sort-by"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tableHeader: Array,
  },
  data() {
    return {
      isAsc: true,
    };
  },
  methods: {
    sortByKey(key) {
      let obj = {
        key: key,
      };
      this.$emit("sort-data", obj);
    },
  },
};
</script>

<style scoped>
.table-row {
  display: table-row;
}
.table-cell {
  display: table-cell;
  padding: 1rem;
  border-top: 2px solid black;
  border-bottom: 1px solid lightgrey;
  background-color: #f9f9f9;
  font-weight: bold;
}
/* .table-cell:nth-child(1) {
  width: 5%;
} */

.sort-by {
  display: block;
  width: 100%;
  padding: 5px;
  position: relative;
  cursor: pointer;
}
.sort-by:before,
.sort-by:after {
  border: 4px solid transparent;
  content: "";
  display: block;
  height: 0;
  top: 50%;
  position: absolute;
  width: 0;
}
.sort-by:before {
  border-bottom-color: #666;
  margin-top: -9px;
}
.sort-by:after {
  border-top-color: #666;
  margin-top: 1px;
}
/* .table-wrapper .table-cell:nth-child(3) {
  width: 50%;
} */
</style>
